export default __webpack_public_path__ + "static/media/P-024.990ead68.png";